import ComponentVueFactory from './ComponentVueFactory'
import ArticleVue from './Article.vue'
import SectionVue from './Section.vue'
import RowsVue from './Rows.vue'
import ColumnsVue from './Columns.vue'
import TextVue from './Text.vue'
import ImageVue from './Image.vue'
import EmbedVue from './Embed.vue'
import UrlVue from './Url.vue'

export default function initialize(): void {
  ComponentVueFactory.register('article', ArticleVue)
  ComponentVueFactory.register('section', SectionVue)
  ComponentVueFactory.register('rows', RowsVue)
  ComponentVueFactory.register('columns', ColumnsVue)
  ComponentVueFactory.register('text', TextVue)
  ComponentVueFactory.register('image', ImageVue)
  ComponentVueFactory.register('embed', EmbedVue)
  ComponentVueFactory.register('url', UrlVue)
  ComponentVueFactory.freeze()
}
